import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGS = [
  { code: 'nl', label: 'NL', flag: '🇳🇱' },
  { code: 'en', label: 'EN', flag: '🇬🇧' },
  { code: 'de', label: 'DE', flag: '🇩🇪' },
];

export const LanguageToggle = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'nl').slice(0, 2);
  return (
    <div
      className={`inline-flex items-center rounded-full border border-white/15 bg-white/5 p-0.5 ${className}`}
      data-testid="language-toggle"
      role="group"
      aria-label="Language"
    >
      {LANGS.map((l) => {
        const active = current === l.code;
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => i18n.changeLanguage(l.code)}
            aria-pressed={active}
            data-testid={`lang-${l.code}`}
            className={`inline-flex items-center gap-1 px-2 py-1 text-xs font-semibold rounded-full transition-colors ${
              active ? 'bg-[#00B4D8] text-black' : 'text-muted-foreground hover:text-white'
            }`}
          >
            <span aria-hidden="true" className="text-[0.95em] leading-none">{l.flag}</span>
            <span>{l.label}</span>
          </button>
        );
      })}
    </div>
  );
};
